import React from "react";
import Modal from "components/base/Modal";
import css from "../style.scss";
import dailyCalGoalLeft from "assets/images/dailyCalGoal.svg";
import CloseBlack from "assets/images/CloseBlack.svg";
import Gift from "assets/images/Gifts.svg";

const CallGoalReached = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            isCloseButton={false}
            uniqId="CallGoalReachedModal"
            width="auto"
            borderRadius="12px"
            modalClassName={css.CallGoalReachedModal}
            onClose={onClose}
        >
            <div className={css.modalWrapper}>
                {/* LEFT SIDE */}
                <div className={css.leftSection}>
                    <img src={dailyCalGoalLeft} alt="call goal" />
                </div>

                {/* RIGHT SIDE */}
                <div className={css.rightSection}>
                    <div className={css.closeBtn} onClick={onClose}>
                        <img src={CloseBlack} alt="close" className={css.closeIcon} />
                    </div>

                    <h2>Daily Call Goal Reached</h2>

                    <p>
                        <span className={css.highlight}>150 calls</span> per day help
                        maintain strong connection rates and protect number reputation. You
                        have completed today's call volume.
                    </p>

                    <p className={css.subHeading}>Want a larger capacity?</p>

                    <p>
                        BatchDialer provides multi-line dialling in addition to limitless
                        calling.
                    </p>

                    <p className={css.offerRow}>
                        <img src={Gift} alt="gift" className={css.giftIcon} />
                        <span>
                            Start a 7-Day Trial & Get{" "}
                            <span className={css.highlight}>20% Off</span> For Life.
                        </span>
                    </p>
                    <div className={css.offerRowbtn}>
                        <button className={css.ctaBtn}
                            onClick={() =>
                                window.open(
                                    "https://batchdialer.com/click2dial",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }>
                            Start Your 7-Day Free Trial
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CallGoalReached;